module.exports = __webpack_public_path__ + "img/ico_tit_pickup.9b0d9b8.svg";